export const BASE_DOC_URL = 'https://doc.saas.olfeo.eu/';

/**
 * Link's documentation
 */
export const documentationContextIds: { [key: string]: string } = {
  // Dashboard tab
  '/trust-center/overview'                        :  'dashboard',
  '/trust-center/statistics'                      :  'stats',
  // SWG
  '/swg/filtering-policies'                       :  'url-policies',
  '/swg/filtering-policies/new'                   :  'url-policies',
  '/swg/filtering-policies/edit'                  :  'url-policies',
  '/swg/safe-search'                              :  'safesearch',
  '/swg/directory'                                :  'directory',
  '/swg/awareness-pages'                          :  'awareness-pages',
  '/swg/awareness-pages/new'                      :  'awareness-pages',
  '/swg/awareness-pages/edit'                     :  'awareness-pages',
  '/swg/charters'                                 :  'charters',
  '/swg/charters/new'                             :  'charters',
  '/swg/charters/edit'                            :  'charters',
  '/swg/decryption'                               :  'decryption',
  '/swg/antivirus'                                :  'antivirus',
  '/swg/filtering-categories'                     :  'categories',

  '/casb/detection'                               :  'app-detection',
  // TOOLS
  '/tools/logs'                                   :  'logs',
  '/tools/url-tester'                             :  'url-tester',
  '/tools/diagnostics'                            :  'livelogs',
  '/tools/in-app-request'                         :  'inapp-requests',
  // Configuration
  '/configuration/sync-directories'               :  'sync-directories',
  '/configuration/sync-directories/edit'          :  'sync-directories',
  '/configuration/sync-directories/edit/#tab1-azure'   :  'sync-directories-azuread-synchro',
  '/configuration/sync-directories/edit/#tab1-adfs'    :  'sync-directories-ad-synchro',
  '/configuration/sync-directories/edit/#tab2-azure'   :  'sync-directories-azuread-saml',
  '/configuration/sync-directories/edit/#tab2-ad'      :  'sync-directories-ad-saml',
  '/configuration/sync-directories/edit/#tab3'         :  'agent-config',
  '/configuration/proxypacs'                      :  'proxypacs',
  '/configuration/proxypacs/new'                  :  'proxypacs',
  '/configuration/proxypacs/edit'                 :  'proxypacs',
  '/configuration/domain-lists'                   :  'domain-lists',
  '/configuration/domain-lists/new'               :  'domain-lists',
  '/configuration/domain-lists/edit'              :  'domain-lists',
  '/configuration/schedules'                      :  'time-slots',
  '/configuration/schedules/new'                  :  'time-slots',
  '/configuration/schedules/edit'                 :  'time-slots',
  '/configuration/schedules/view'                 :  'time-slots',
  '/configuration/log-connector'                  :  'log-connectors',
  '/configuration/log-connector/new'              :  'log-connectors',
  '/configuration/log-connector/edit'             :  'log-connectors',
  '/configuration/log-connector/view'             :  'log-connectors',
  '/configuration/global-parameters'              :  'configuration',

  '/administration/administrators'                 :  'administrators',
  '/administration/administrators/new'             :  'administrators',
  '/administration/administrators/edit'            :  'administrators',
  '/administration/admin-logs'                     :  'administration-logs',
  // Support
  '/support/contact'                              :  BASE_DOC_URL
};

